import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router';
import Wizard from 'components/Wizard';
import QuickPage from 'containers/SubmissionSteps/QuickPage';
import BasicsPage from 'containers/SubmissionSteps/BasicsPage';
import DetailsPage from 'containers/SubmissionSteps/DetailsPage';
import TicketsPage from 'containers/SubmissionSteps/TicketsPage';
import LinksPage from 'containers/SubmissionSteps/LinksPage';
import ImagesPage from 'containers/SubmissionSteps/ImagesPage';
import ContactPage from 'containers/SubmissionSteps/ContactPage';
import PreviewPage from 'containers/SubmissionSteps/PreviewPage';
import FinalSubmissionPage from 'containers/SubmissionSteps/FinalSubmissionPage';
import * as submissionFormActions from 'actions/submissionFormActions';
import { checkEventEligibility } from 'actions/publishersActions';
import { bindActionCreators } from 'redux';
import { trackPageView } from 'lib/eventTracking'

class SubmissionWizardContainer extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    stepDetails: ImmutablePropTypes.map.isRequired,
    submissionForm: ImmutablePropTypes.map.isRequired,
    config: ImmutablePropTypes.map.isRequired,
    preloadImages: PropTypes.func.isRequired,
    preloadStepsState: PropTypes.func.isRequired,
    quickFormActive: PropTypes.bool.isRequired,
    snapSellPackageId: PropTypes.number,
    packageType: PropTypes.string,
    switchForm: PropTypes.func
  };

  getStepDetails(step) {
    const { stepDetails } = this.props;
    return {
      path: stepDetails.getIn([step, 'path']),
      accessible: stepDetails.getIn([step, 'accessible']),
      completed: stepDetails.getIn([step, 'completed']),
      onClick: this.changeStep
    };
  }

  componentDidMount() {
    trackPageView(this.props.quickFormActive ? 'Quick Submission Form' : 'Full Submission Form' );

    if (this.props.submissionForm.getIn(['data', 'images']).size === 0) {
      this.props.preloadImages();
    }
    this.props.switchForm(this.props.quickFormActive ? 'quick' : 'full');
    this.props.preloadStepsState(this.props.history);
    this.props.dispatch(checkEventEligibility());
  }

  getSteps() {
    const fullSteps = [
      {
        name: 'Basics',
        faIconClass: 'fa fa-calendar',
        component: BasicsPage,
        ...this.getStepDetails('basics')
      },
      {
        name: 'Details',
        faIconClass: 'fa fa-edit',
        component: DetailsPage,
        ...this.getStepDetails('details')
      },
      {
        name: 'Tickets',
        faIconClass: 'fa fa-ticket',
        component: TicketsPage,
        ...this.getStepDetails('tickets')
      },
      {
        name: 'Images',
        faIconClass: 'fa fa-image',
        component: ImagesPage,
        ...this.getStepDetails('images')
      },
      {
        name: 'URLs',
        faIconClass: 'fa fa-link',
        component: LinksPage,
        ...this.getStepDetails('links'),
      },
      {
        name: 'Contact',
        faIconClass: 'fa fa-user',
        component: ContactPage,
        ...this.getStepDetails('contact'),
      },
      {
        name: 'Preview',
        faIconClass: 'fa fa-search',
        component: PreviewPage,
        ...this.getStepDetails('preview'),
      },
    ];

    const quickSteps = [
      {
        name: 'Details',
        faIconClass: 'fa fa-edit',
        component: QuickPage,
        ...this.getStepDetails('quick')
      },
      {
        name: 'Preview',
        faIconClass: 'fa fa-search',
        component: PreviewPage,
        ...this.getStepDetails('preview'),
      },
    ];

    return this.props.quickFormActive ? quickSteps : fullSteps;
  }

  changeStep = (stepIndex) => {
    trackPageView(this.getSteps()[stepIndex - 1].name );
    this.props.history.push({ pathname: this.getSteps()[stepIndex - 1].path });
  }

  getDefaultStep() {
    if (this.isSnapSellPage()) {
      return '/snap-sell';
    } else if (this.props.quickFormActive) {
      return '/quick';
    } else {
      return '/basics';
    }
  }

  userHasCredits() {
    const { userLoggedIn, currentUser, pricingTierLevel } = this.props;
    if (!userLoggedIn) return;

    const availablePricingTiers = currentUser.get('available_pricing_tiers');

    if (availablePricingTiers) {
      return pricingTierLevel <= availablePricingTiers.max();
    }
  }

  isSnapSellPage() {
    if (this.userHasCredits()) return;

    const { config, snapSellPackageId, packageType } = this.props;

    return config.get('snap_sell_enabled') && !snapSellPackageId && packageType !== 'free';
  }

  render() {
    const steps = this.getSteps();

    return (
      <Wizard
        steps={steps}
        location={this.props.location.pathname}
        onStepChange={this.changeStep}
        history={this.props.history}
        submissionForm={this.props.submissionForm}
      >
        <Switch>
          {steps.map(step => <Route key={`step${step.path}`} path={step.path} component={step.component}/>)}
          <Route path="/submit" component={FinalSubmissionPage} />
          <Redirect from="/" to={this.getDefaultStep()}/>
        </Switch>
      </Wizard>
    );
  }
}

const mapStateToProps = (state) => ({
  packageType: state.checkoutData.get('package_type'),
  stepDetails: state.submissionForm.get('steps'),
  submissionForm: state.submissionForm,
  quickFormActive: state.form.eventSubmission.values.quick_form,
  snapSellPackageId: state.checkoutData.get('snap_sell_package_id'),
  config: state.config,
  currentUser: state.currentUser.get('data'),
  userLoggedIn: state.currentUser.get('isLoggedIn'),
  pricingTierLevel: state.checkoutData.get('pricing_tier_level')
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  ...bindActionCreators(submissionFormActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubmissionWizardContainer);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/containers/SubmissionWizardContainer.jsx